import _ from 'underscore';

export const getPlacementStyles = ({ styleOverrides, isIncluded }) => () => {
  const overrides = _.pick(styleOverrides, 'placementContainer', 'headerImage', 'cardParent');

  return {
    placementContainer: _.extend({
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      opacity: isIncluded ? '100%' : '50%',
    }, overrides.placementContainer),
    cardParent: _.extend({
    }, overrides.cardParent),
    headerImage: _.extend({
    }, overrides.headerImage),
  };
};
